import React, { useEffect } from "react";
import "./Content.css";
import {
  RiNumber1,
  RiNumber2,
  RiNumber3,
  RiNumber4,
  RiNumber5,
  RiNumber6,
  RiNumber7,
  RiNumber8,
} from "react-icons/ri";
import { FaDev } from "react-icons/fa";
import { ReactComponent as PlanSVG } from "../../images/plan.svg";
import { ReactComponent as CodingSVG } from "../../images/coding-icon.svg";
import { ReactComponent as CompileSVG } from "../../images/inspect-icon.svg";
import { ReactComponent as FixSVG } from "../../images/errorbug-icon.svg";
import { ReactComponent as CoderSVG } from "../../images/success-coder.svg";
import { ReactComponent as PushSVG } from "../../images/push-icon.svg";
import { ReactComponent as CodeThinkSVG } from "../../images/codethinking.svg";
import { ReactComponent as CodeTesting } from "../../images/code-testing.svg";

import Title from "../Title/Title";
import AOS from "aos";
import "aos/dist/aos.css";

const Content = () => {
  useEffect(() => {
    AOS.init({ duration: 3000 });
    AOS.refresh();
  }, []);
  return (
    <>
      <div className="education-logo">
        <Title title="Theories learnt as a Web Developer" />
        <FaDev className="degree-icon mt-15" />
      </div>
      <div className="section-content">
        {/* Number -1 */}
        <div className="content-box" data-aos="fade-up-right">
          <PlanSVG className="content-icon" />
          <span className="content-ptag">
            <span className="content-numbering-left">
              <RiNumber1 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Planning</span> is needed to work on
              any projects that you rely upon. This helps in making a sketch of
              what is to be done and how it is to be done. The structural part
              of the code is initiated here, that allows to what which codes and
              component can be reused in multiple pages. Sketching the codes
              will make it understand to work in easier ways and can formalise
              unwanted components and pages from the project
            </p>
          </span>
        </div>
        {/* Number -2 */}
        <div className="content-box" data-aos="fade-up-left">
          <span className="content-ptag">
            <span className="content-numbering-right">
              <RiNumber2 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Coding</span> is performed with the
              techniques that are needed for an organization that enhances the
              styles and the functional part, this is the playground to play
              around with all the concepts that runs in the mind, the
              challenging part is to make your code neat and clean with all the
              necessary comments that are used for the actions to perform such
              as authentication, naviagtion,saving datas to backend
            </p>
          </span>
          <CodingSVG className="content-icon" />
        </div>
        {/* Number -3 */}
        <div className="content-box" data-aos="fade-up-right">
          <CompileSVG className="content-icon" />
          <span className="content-ptag">
            <span className="content-numbering-left">
              <RiNumber3 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Compilation</span> is performed once
              the codes are been connected properly with frontend and backend of
              the project, it gives you a list of messages stating that what
              warnings and errors are been perfomed while working on the code
              part, its something like glimpse of the project, it identifies and
              unwanted values or functions that are not excuted properly
            </p>
          </span>
        </div>
        {/* Number -4 */}
        <div className="content-box" data-aos="fade-up-left">
          <span className="content-ptag">
            <span className="content-numbering-right">
              <RiNumber4 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Error Handling</span> is the major
              part of the compilation, it helps you to find in which code line
              the error is been identified with its value, so according to the
              code structure the developer can make changes like removing or
              editing the specific part of the code
            </p>
          </span>
          <CodeThinkSVG className="content-icon" />
        </div>

        {/* Number -5 */}
        <div className="content-box" data-aos="fade-up-right">
          <FixSVG className="content-icon" />
          <span className="content-ptag">
            <span className="content-numbering-left">
              <RiNumber5 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Rectifying code</span> can help to
              filter more unused or unwanted functions/components to make the
              code clean and crisp with all the needed functional part of the
              code
            </p>
          </span>
        </div>

        {/* Number -6 */}
        <div className="content-box" data-aos="fade-up-left">
          <span className="content-ptag">
            <span className="content-numbering-right">
              <RiNumber6 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Testing</span> is one of the major
              procedure that has to be implemented when the code gets completed
              and works with your browser. The testing of an application can be
              classified using two options first is maunal tesing(which helps to
              find whether 100% of the application aim is acheived by manual
              execution) and second is automated testing a.k.a end-to-end
              testing(which has a testing library for initiating the test with
              components and provides results according to the components
              executed). The familiar rule is to use automated testing for each
              and every components to avoid unwanted or unused merging of
              states/functions/context rules throughout the applications and
              each javascript frameworks do have testing frameworks like
              cypress,jest,karma,react-testing libraries.
            </p>
          </span>
          <CodeTesting className="content-icon" />
        </div>

        {/* Number -7 */}
        <div className="content-box" data-aos="fade-up-right">
          <PushSVG className="content-icon" />
          <span className="content-ptag">
            <span className="content-numbering-left">
              <RiNumber7 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">Commits and Push to Github</span> in
              order to make sure the code is saved when major of the changes are
              done regularly. Commiting and pushing the code according to the
              branch names, and merging same codes together could help to have a
              view the difference between old code and the new code
            </p>
          </span>
        </div>

        {/* Number -8 */}
        <div className="content-box" data-aos="fade-up-left">
          <span className="content-ptag">
            <span className="content-numbering-right">
              <RiNumber8 className="content-number-image" />
            </span>
            <p className="content-text">
              <span className="first-text">
                Deploy and Publish to real world
              </span>{" "}
              is a successful thing where a devloper can confidently push a
              project wihout any errors to the public for regular accessing, so
              that it can groove everywhere
            </p>
          </span>
          <CoderSVG className="content-icon" />
        </div>
      </div>
    </>
  );
};

export default Content;
